var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.breadcrumbs.length
    ? _c("div", { staticClass: "block-breadcrumbs" }, [
        _c(
          "div",
          { ref: "scrollView", staticClass: "content" },
          [
            _c("a", {
              attrs: { href: "/" },
              domProps: { textContent: _vm._s(_vm.$t("home")) }
            }),
            _vm._l(_vm.breadcrumbs, function(item) {
              return _c("a", {
                key: item.id,
                attrs: { href: item.path },
                domProps: { textContent: _vm._s(item.name) }
              })
            })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }